// Helpers for the "premium intent" handoff between landing-page CTAs and the
// auth dialog. The landing page sets `localStorage.premium_intent` to a JSON
// blob like `{ "plan": "premium-monthly", "expiresAt": <epoch-ms> }`. The auth
// dialog reads it to render a hint banner and to pick the post-auth redirect.

const KEY = "premium_intent";

export function readPremiumIntent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;

    // Tolerate the legacy plain-string form (just a plan id) as well as the
    // structured `{plan, expiresAt}` form.
    let parsed;
    try {
      parsed = JSON.parse(raw);
    } catch {
      parsed = { plan: raw };
    }

    const plan = typeof parsed === "string" ? parsed : parsed?.plan;
    if (!plan) return null;

    const expiresAt = parsed?.expiresAt;
    if (typeof expiresAt === "number" && Date.now() > expiresAt) {
      localStorage.removeItem(KEY);
      return null;
    }

    return { plan, expiresAt: expiresAt ?? null };
  } catch {
    return null;
  }
}

export function clearPremiumIntent() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore (private mode etc.)
  }
}

export function setPremiumIntent(plan, ttlMs = 30 * 60 * 1000) {
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ plan, expiresAt: Date.now() + ttlMs })
    );
  } catch {
    // ignore
  }
}
